import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import View from './View';
import {getFormData} from '@nexios/frontend-forms';

const getThankYouTextFields = (formData) => {
  const showDonationFields = formData.showDonationFields;
  const isOneOff = formData.frequency === 'oneOff';
  const isDirectDebit = formData.paymentMethod === 'directDebit';

  if (showDonationFields && isOneOff && isDirectDebit)
    return {textField: 'oneOffThankYouTextHtml_txt', titleField: 'oneOffThankYouTitle'};
  else if (showDonationFields && isOneOff)
    return {textField: 'donationThankYouTextHtml_txt', titleField: 'donationThankYouTitle'};
  else if (showDonationFields)
    return {textField: 'continuousThankYouTextHtml_txt', titleField: 'continuousThankYouTitle'};
  else
    return {textField: 'leadTextHtml_txt', titleField: 'leadTitle'};
};

const getAskConfig = (formData, formContext) => {
  const showDonationFields = formData.showDonationFields;
  const isOneOff = formData.frequency === 'oneOff';
  const alreadyAsked = formData.isThankYouAsk;

  if (!showDonationFields || (alreadyAsked && isOneOff)) {
    return {askConfig: formContext.thankYouAskOneOffConfig, askType: 'oneOff'};
  }
  if (isOneOff || alreadyAsked) {
    return {askConfig: formContext.thankYouAskRecurringConfig, askType: 'recurring'};
  }
  return {};
};

const Lead2 = ({formContext, formData, themeName}) => {
  const {textField, titleField} = getThankYouTextFields(formData);
  const {askConfig, askType} = getAskConfig(formData, formContext);
  return <View
    formContext={formContext}
    themeName={themeName}
    textField={textField}
    titleField={titleField}
    askType={askType}
    askConfig={askConfig} />;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext,
    formData: getFormData(state, 'donate'),
    themeName: state.reducer.theme
  };
};

export default connect(mapStateToProps)(withRouter(Lead2));

